export default "__VITE_ASSET__Da4QFYg6__"